// extracted by mini-css-extract-plugin
export var footer = "_sl-0";
export var inherit = "_sl-1";
export var input = "_sl-2";
export var modalContent = "_sl-3";
export var quillEditor = "_sl-4";
export var subtitle = "_sl-5";